import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

import { selectState as selectStateConfig } from '../configs.selector';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateConfig, selectStateKey);
